import { render, staticRenderFns } from "./QRIssue.vue?vue&type=template&id=37a005de&"
import script from "./QRIssue.vue?vue&type=script&lang=js&"
export * from "./QRIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports